import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { 
  FaBars, 
  FaSearch, 
  FaBell, 
  FaEnvelope, 
  FaUserCircle,
  FaCog,
  FaSignOutAlt
} from 'react-icons/fa';

/**
 * 顶部导航栏组件
 * @param {function} toggleSidebar - 切换侧边栏显示状态的函数
 */
const Header = ({ toggleSidebar }) => {
  const { currentUser, logout } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  
  // 未读通知数量（示例）
  const notificationsCount = 3;
  
  // 切换用户菜单显示状态
  const toggleUserMenu = () => {
    setShowUserMenu(!showUserMenu);
    // 如果打开用户菜单，关闭通知菜单
    if (!showUserMenu) {
      setShowNotifications(false);
    }
  };
  
  // 切换通知菜单显示状态
  const toggleNotifications = () => {
    setShowNotifications(!showNotifications);
    // 如果打开通知菜单，关闭用户菜单
    if (!showNotifications) {
      setShowUserMenu(false);
    }
  };
  
  // 处理退出登录
  const handleLogout = () => {
    logout();
  };
  
  return (
    <header className="header">
      <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm">
        <div className="container-fluid px-4">
          {/* 左侧菜单切换按钮 */}
          <button 
            className="btn btn-link text-dark d-md-none me-3 p-0"
            onClick={toggleSidebar}
          >
            <FaBars size={20} />
          </button>
          
          {/* 搜索表单 */}
          <form className="d-none d-md-flex ms-md-3 me-auto">
            <div className="input-group">
              <span className="input-group-text bg-light border-end-0">
                <FaSearch className="text-muted" />
              </span>
              <input 
                type="search" 
                className="form-control border-start-0 bg-light" 
                placeholder="搜索..." 
                aria-label="搜索" 
              />
            </div>
          </form>
          
          <div className="d-flex align-items-center">
            {/* 通知图标 */}
            <div className="dropdown me-3 position-relative">
              <button
                className="btn btn-link text-dark p-0"
                onClick={toggleNotifications}
              >
                <FaBell size={18} />
                {notificationsCount > 0 && (
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {notificationsCount}
                    <span className="visually-hidden">未读通知</span>
                  </span>
                )}
              </button>
              
              {/* 通知下拉菜单 */}
              {showNotifications && (
                <div className="dropdown-menu dropdown-menu-end shadow-sm show p-0" style={{ minWidth: '300px' }}>
                  <div className="dropdown-header d-flex justify-content-between align-items-center py-2 px-3 border-bottom">
                    <span className="fw-bold">通知</span>
                    <Link to="/notifications" className="text-decoration-none small">查看全部</Link>
                  </div>
                  <div className="notification-list">
                    <Link to="/notifications/1" className="dropdown-item border-bottom py-2 px-3 d-flex">
                      <div className="me-3">
                        <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }}>
                          <FaBell />
                        </div>
                      </div>
                      <div>
                        <p className="mb-0 fw-bold">网站变更提醒</p>
                        <span className="text-muted small">example.com 有内容更新</span>
                        <p className="text-muted small mb-0">10分钟前</p>
                      </div>
                    </Link>
                    <Link to="/notifications/2" className="dropdown-item border-bottom py-2 px-3 d-flex">
                      <div className="me-3">
                        <div className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }}>
                          <FaEnvelope />
                        </div>
                      </div>
                      <div>
                        <p className="mb-0 fw-bold">监控提醒</p>
                        <span className="text-muted small">example.org 无法连接</span>
                        <p className="text-muted small mb-0">30分钟前</p>
                      </div>
                    </Link>
                    <Link to="/notifications/3" className="dropdown-item py-2 px-3 d-flex">
                      <div className="me-3">
                        <div className="bg-warning text-white rounded-circle d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }}>
                          <FaUserCircle />
                        </div>
                      </div>
                      <div>
                        <p className="mb-0 fw-bold">账户提醒</p>
                        <span className="text-muted small">您的账户将于7天后到期</span>
                        <p className="text-muted small mb-0">1天前</p>
                      </div>
                    </Link>
                  </div>
                </div>
              )}
            </div>
            
            {/* 用户资料下拉菜单 */}
            <div className="dropdown">
              <button
                className="btn btn-link p-0 d-flex align-items-center text-decoration-none"
                onClick={toggleUserMenu}
              >
                <div className="avatar bg-primary text-white rounded-circle d-flex justify-content-center align-items-center me-2" style={{ width: 36, height: 36 }}>
                  {currentUser?.name?.charAt(0) || 'U'}
                </div>
                <span className="d-none d-md-inline-block text-dark me-1">
                  {currentUser?.name || '用户'}
                </span>
              </button>
              
              {/* 用户菜单 */}
              {showUserMenu && (
                <div className="dropdown-menu dropdown-menu-end shadow-sm show" style={{ minWidth: '200px' }}>
                  <div className="dropdown-header d-flex flex-column align-items-center p-3 border-bottom">
                    <div className="avatar bg-primary text-white rounded-circle d-flex justify-content-center align-items-center mb-2" style={{ width: 50, height: 50 }}>
                      {currentUser?.name?.charAt(0) || 'U'}
                    </div>
                    <h6 className="mb-0">{currentUser?.name || '用户'}</h6>
                    <span className="text-muted small">{currentUser?.email || ''}</span>
                  </div>
                  <Link to="/profile" className="dropdown-item py-2">
                    <FaUserCircle className="me-2" /> 个人资料
                  </Link>
                  <Link to="/profile/settings" className="dropdown-item py-2">
                    <FaCog className="me-2" /> 账户设置
                  </Link>
                  <div className="dropdown-divider"></div>
                  <button 
                    className="dropdown-item text-danger py-2" 
                    onClick={handleLogout}
                  >
                    <FaSignOutAlt className="me-2" /> 退出登录
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header; 